module.exports = __webpack_public_path__ + "static/media/12UNCTAD16.c31b9650.jpg";